export const TableHead = ({ children }) => (
  <thead>
    <tr>{children}</tr>
  </thead>
);
